class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));
    facetForm.addEventListener("select", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop",
    );

    document.getElementById("product-grid").classList.add("loading");
    if (countContainer) countContainer.classList.add("loading");
    if (countContainerDesktop) countContainerDesktop.classList.add("loading");

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("product-grid").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("product-grid").innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element),
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`,
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter"),
      );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");
    const targetElementAccessibility = target.querySelector(".facets__summary");
    const sourceElementAccessibility = source.querySelector(".facets__summary");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector(".facets__summary").outerHTML =
        source.querySelector(".facets__summary").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form",
    );

    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form"),
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";
      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1,
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

// Patch renderFilters to dispatch facets:updated (for sliders, ready-to-deliver)
const originalRenderFilters = FacetFiltersForm.renderFilters;
FacetFiltersForm.renderFilters = function (html, event) {
  originalRenderFilters.call(this, html, event);
  document.dispatchEvent(new Event("facets:updated"));
};

// Patch renderProductGridContainer to dispatch grid:updated (for load more)
// This fires AFTER the grid DOM is replaced, so the new button is guaranteed to exist
const originalRenderGrid = FacetFiltersForm.renderProductGridContainer;
FacetFiltersForm.renderProductGridContainer = function (html) {
  originalRenderGrid.call(this, html);
  document.dispatchEvent(new Event("grid:updated"));
};

// ============================================================
// Custom Elements
// ============================================================

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this)),
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();

    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    const facetLink = event.currentTarget;

    const labelSpan = facetLink.querySelector(".active-facets__button-inner");
    const labelText = labelSpan
      ? labelSpan.textContent.trim().toLowerCase()
      : "";

    const isReadyToDeliver = labelText.startsWith("ready to deliver");

    if (isReadyToDeliver) {
      const realFilter = document.querySelector(
        'input[name="filter.v.m.custom.ready_to_deliver"]',
      );
      const custom = document.getElementById("ReadyToDeliverSwitch");

      if (realFilter) {
        realFilter.checked = false;
        realFilter.dispatchEvent(new Event("input", { bubbles: true }));
      }

      if (custom) {
        custom.checked = false;
        custom.disabled = false;
        const toggleLabel = custom.closest("label");
        if (toggleLabel)
          toggleLabel.classList.remove("facet-checkbox--disabled");
      }
    }

    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);

// ============================================================
// Range Sliders
// ============================================================

function getVals() {
  var parent = this.parentNode;
  var selectorparent = SearchParentsFor(parent, "facets__price");
  var pricesvalueInputs = parent.querySelectorAll("input[type='range']");
  var min_valueInput = parseFloat(pricesvalueInputs[0].value);
  var max_valueInput = parseFloat(pricesvalueInputs[1].value);
  var CurrencySymbol = parent.getAttribute("data-CurrencySymbol");

  if (min_valueInput > max_valueInput) {
    [min_valueInput, max_valueInput] = [max_valueInput, min_valueInput];
  }

  var min_value = parent.querySelector(".rangeValues .min_value");
  var max_value = parent.querySelector(".rangeValues .max_value");

  min_value.innerHTML = CurrencySymbol + min_valueInput;
  max_value.innerHTML = CurrencySymbol + max_valueInput;

  parent.querySelector(".rangeValues_label .min_value").innerHTML =
    CurrencySymbol + min_valueInput;
  parent.querySelector(".rangeValues_label .max_value").innerHTML =
    CurrencySymbol + max_valueInput;

  var min_value_textbox = selectorparent.querySelector(
    'input[name="filter.v.price.gte"]',
  );
  var max_value_textbox = selectorparent.querySelector(
    'input[name="filter.v.price.lte"]',
  );
  min_value_textbox.value = min_valueInput;
  max_value_textbox.value = max_valueInput;
}

function initializeRangeSliders() {
  var sliderSections = document.querySelectorAll(".range-slider");
  sliderSections.forEach((sliderSection) => {
    var sliders = sliderSection.querySelectorAll("input[type='range']");
    sliders.forEach((slider) => {
      slider.addEventListener("input", getVals);
      slider.dispatchEvent(new Event("input"));
    });
  });
}

// ============================================================
// Ready to Deliver Toggle
// ============================================================

function initReadyToDeliverToggle() {
  const custom = document.getElementById("ReadyToDeliverSwitch");
  const real = document.querySelector(
    'input[name="filter.v.m.custom.ready_to_deliver"]',
  );
  if (!custom || !real) return;

  custom.checked = real.checked;
  custom.disabled = real.disabled;

  const toggleLabel = custom.closest("label");
  if (toggleLabel)
    toggleLabel.classList.toggle("facet-checkbox--disabled", real.disabled);
}

// ============================================================
// Load More
// ============================================================

async function initLoadMore() {
  const button = document.getElementById("loadMore");
  const container = document.getElementById("productListItems");

  if (!button || !container) return;

  const sectionId = button.dataset.sectionId;

  async function fetchPage(pageNum) {
    const params = new URLSearchParams(window.location.search);
    params.set("page", pageNum);
    params.set("section_id", sectionId);
    const response = await fetch(
      `${window.location.pathname}?${params.toString()}`,
    );
    if (!response.ok) throw new Error("Network response was not ok");
    const html = await response.text();
    return new DOMParser().parseFromString(html, "text/html");
  }

  async function hasProducts(pageNum) {
    const doc = await fetchPage(pageNum);
    const items = doc.querySelector("#productListItems");
    return items && items.children.length > 0;
  }

  // Reset state for this render cycle
  button.dataset.nextPage = "2";
  button.disabled = true;
  button.style.visibility = "hidden";

  // Remove any click listener from a previous render cycle
  button.replaceWith(button.cloneNode(true));
  const freshButton = document.getElementById("loadMore");

  const page2Exists = await hasProducts(2);
  if (!page2Exists) {
    freshButton.style.visibility = "hidden";
    return;
  }

  freshButton.style.visibility = "";
  freshButton.disabled = false;
  freshButton.textContent = "Load more";

  async function loadMoreProducts() {
    const nextPage = parseInt(freshButton.dataset.nextPage, 10);

    freshButton.disabled = true;
    freshButton.textContent = "Loading…";

    try {
      const doc = await fetchPage(nextPage);
      const newProducts = doc.querySelector("#productListItems");

      if (!newProducts || newProducts.children.length === 0) {
        freshButton.style.visibility = "hidden";
        return;
      }

      container.insertAdjacentHTML("beforeend", newProducts.innerHTML);

      const pageAfterNext = nextPage + 1;
      freshButton.dataset.nextPage = pageAfterNext;

      const moreExist = await hasProducts(pageAfterNext);
      if (!moreExist) {
        freshButton.style.visibility = "hidden";
      } else {
        freshButton.disabled = false;
        freshButton.textContent = "Load more";
      }
    } catch (error) {
      console.error(error);
      freshButton.textContent = "Try again";
      freshButton.disabled = false;
    }
  }

  freshButton.addEventListener("click", loadMoreProducts);
}
// ============================================================
// Mobile Sort
// ============================================================

function mobileSortEventHandler() {
  $('input[name="sort_by"]').on("change", function (e) {
    var value = e.currentTarget.value;
    var sortSelect = document.querySelector("#SortBy");
    for (var i = 0; i < sortSelect.options.length; i++) {
      if (sortSelect.options[i].value === value) {
        sortSelect.options.selectedIndex = i;
        break;
      }
    }
  });
}

// ============================================================
// Event Listeners
// ============================================================

// facets:updated — fires after renderFilters (filter UI replaced)
// Use for anything that lives in the filter sidebar
document.addEventListener("facets:updated", function () {
  initReadyToDeliverToggle();
  initializeRangeSliders();
});

// grid:updated — fires after renderProductGridContainer (product grid replaced)
// Use for anything that lives inside #product-grid
document.addEventListener("grid:updated", function () {
  initLoadMore();
});

document.addEventListener("DOMContentLoaded", function () {
  initReadyToDeliverToggle();
  initializeRangeSliders();
  mobileSortEventHandler();
  initLoadMore();

  const custom = document.getElementById("ReadyToDeliverSwitch");
  if (!custom) return;

  custom.addEventListener("change", () => {
    const real = document.querySelector(
      'input[name="filter.v.m.custom.ready_to_deliver"]',
    );
    if (!real || real.disabled) return;
    real.click();
  });

  // Save existing sort parameters
  Shopify.queryParams = {};
  if (location.search.length) {
    for (
      var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
      i < aCouples.length;
      i++
    ) {
      aKeyValue = aCouples[i].split("=");
      if (aKeyValue && aKeyValue[0] == "sort_by") {
        var currentMobileSort = document.querySelector(
          'input[name="sort_by"][value="' + aKeyValue[1] + '"]',
        );
        if (currentMobileSort) {
          currentMobileSort.checked = true;
          currentMobileSort
            .closest(".facet-checkbox")
            .classList.add("facet-mobile-sort-active");
        }
      }
    }
  }

  // Add existing sort parameters to current URL
  var optionsContainer = document.querySelector(
    ".bridgman-mobile-sort-container",
  );
  var options = optionsContainer.querySelectorAll(
    ".bridgman--sort--container .facet-checkbox",
  );
  for (var i = 0; i < options.length; i++) {
    var option = options[i];
    option.addEventListener("click", function (e) {
      var element = e.currentTarget.querySelector('input[name="sort_by"]');
      var activeSort = document.querySelector(
        ".bridgman--sort--container .facet-checkbox.facet-mobile-sort-active",
      );
      if (activeSort) {
        activeSort.classList.remove("facet-mobile-sort-active");
      }
      e.currentTarget.classList.add("facet-mobile-sort-active");
      var value = element.value;
      Shopify.queryParams.sort_by = value;
      location.search = new URLSearchParams(Shopify.queryParams).toString();
    });
  }
});
